export default "__VITE_ASSET__a3ce4596__"